<template>
  <div class="guide">
    <guide-title tag_type="h2" />
    <div class="date">2020/07/22 鈨組</div>
    <div class="intro main_text">
      鈨組が作成する「天ノ葉神社日本支部」の動画等に登場するキャラクターの⼆次創作品を作成する際には、以下のガイドラインへの同意をお願いいたします。<br />
      同意いただけない場合は、本キャラクターの⼆次創作品を公開することはできません。<br />
      なお、本ガイドラインは予告なく変更を⾏う場合があります。
    </div>
    <h3 class="guideline-heading">許容範囲</h3>
    <div class="main_text">
      以下の条件のもと、⼆次創作品を許容させていただきます。
      なお、⼆次創作品を公開する際には、申請等の連絡は必要ありません。
      <ol>
        <li>キャラクターのイメージを⼤きく損なわないもの</li>
        <li>営利⽬的でないもの</li>
        <li>以下、禁⽌⾏為に該当しないもの</li>
      </ol>
    </div>
    <h3 class="guideline-heading">禁止行為</h3>
    <div class="main_text">
      以下の⾏為に該当するような⼆次創作品の公開はおやめください。
      <ol>
        <li>公序良俗に反する表現、暴力的または反社会的な表現、これらの行為や目的に関連する利用</li>
        <li>鈨組や本キャラクター公式の作品・製品であるとの誤解を招く表現がある利用</li>
        <li>第三者の権利や名誉を侵害する利用</li>
      </ol>
    </div>
    <h3 class="guideline-heading">動画の切り抜きに関して</h3>
    <div class="main_text">
      鈨組や本キャラクターが公開した動画の⼀部分を切り取り、編集したものを公開する際には、<br />
      必ず元の動画へのリンクを含めてください。<br />
      また、これにより作成した動画に広告を付けることはおやめください。
    </div>
  </div>
</template>

<script>
import guideTitle from '../components/shared/guide_title'

export default {
  components: {
    guideTitle
  }
}
</script>

<style lang="scss" scoped>
@import '../stylesheets/variables';

.guide {
  font-weight: 100;
  color: $text-white;
}

.guideline-heading {
  font-weight: 300;
  font-size: 20px;
}

.main_text {
  margin: 0 0 1em 1.5em;
}

.guide ::v-deep {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 80%;
  padding: 0 10%;
  text-align: left;

  .date {
    margin-bottom: 1em;
  }

  .guide_title {
    width: 100%;
    align-items: center;
  }
}
</style>
